module.exports = __webpack_public_path__ + "img/logo.06c07155.png";